import { Flex, Text } from '@chakra-ui/react';
import { CustomInfoIcon } from '../../../theme/icons/CustomInfoIcon';
import type { BuilderPassTab } from './utils/templateBuilderTabs';
import { BUILDER_PASS_TAB } from './utils/templateBuilderTabs';

interface TabsNudgeBannerProps {
  onNavigateToTab: (tab: BuilderPassTab) => void;
}

export const TabsNudgeBannerContent = ({
  onNavigateToTab,
}: TabsNudgeBannerProps) => {
  const handleClick = (tab: BuilderPassTab) => {
    onNavigateToTab(tab);
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
  };

  return (
    <Text fontSize="14px" color="rgba(0, 0, 0, 0.8)">
      We recommend checking the{' '}
      <Text
        as="span"
        textDecoration="underline"
        cursor="pointer"
        onClick={() => handleClick(BUILDER_PASS_TAB.BACK)}
      >
        Additional
      </Text>{' '}
      and{' '}
      <Text
        as="span"
        textDecoration="underline"
        cursor="pointer"
        onClick={() => handleClick(BUILDER_PASS_TAB.FEATURES)}
      >
        Features
      </Text>{' '}
      tabs before you finish.
    </Text>
  );
};

const TabsNudgeBanner = ({ onNavigateToTab }: TabsNudgeBannerProps) => (
  <Flex
    align="center"
    gap={3}
    mt={3}
    px="14px"
    py="8px"
    bg="rgba(0, 155, 214, 0.1)"
    borderRadius="5px"
  >
    <CustomInfoIcon color="#009BD6" boxSize="21px" flexShrink={0} />
    <TabsNudgeBannerContent onNavigateToTab={onNavigateToTab} />
  </Flex>
);

export default TabsNudgeBanner;
